import { useLingui } from "@lingui/react";
import type { MouseEventHandler } from "react";
import { useAdViewAd } from "src/context/AdViewProviderContext.tsx";
import { useGallery } from "./state.tsx";
import { scrollIntoView } from "./util.ts";

export const Overview = () => {
  const { i18n } = useLingui();

  const { images } = useAdViewAd();
  const { setCurrentImageIndex, toggleOverview } = useGallery();

  const selectImage = (index: number): MouseEventHandler => {
    return (event) => {
      toggleOverview(event);
      setCurrentImageIndex(index);
      setTimeout(() => scrollIntoView(index), 50);
    };
  };

  return (
    <ul className="flex flex-wrap gap-16 justify-center mx-16 overflow-y-auto">
      {images.map((image, index) => (
        <li key={image.uri} style={{ lineHeight: 0 }}>
          <button
            type="button"
            onClick={selectImage(index)}
            aria-label={`${i18n.t({ id: "itemPageLayout.imageGallery.overview.goto", message: "Go to image number" })} ${index + 1}`}
          >
            <img style={{ maxWidth: "20rem", maxHeight: "13rem" }} src={image.uri} alt={image.description} />
          </button>
        </li>
      ))}
    </ul>
  );
};
